import type { GlobalCal, PrefillAndIframeAttrsConfig } from "@calcom/embed-core"
import { getCalApi } from "@calcom/embed-react"
import Component from "@glimmer/component"
import { tracked } from "@glimmer/tracking"
import CalEmbed from "react-app/components/user/unlock-group-form/CalEmbed"

export interface CalEmbedSig {
  Args: {
    namespace: string
    calLink: string
    config: PrefillAndIframeAttrsConfig
    onMeetingScheduled: (event: CustomEvent) => void
  }
}

export default class CalEmbedComponent extends Component<CalEmbedSig> {
  CalEmbed = CalEmbed

  @tracked
  cal: GlobalCal | null = null

  constructor(owner: unknown, args: CalEmbedSig["Args"]) {
    super(owner, args)
    ;(async () => {
      // We need to supply namespace here or else `hideEventTypeDetails: true` is ignored in CalEmbed.
      this.cal = (await getCalApi({ namespace: args.namespace })) as GlobalCal
    })()
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "User::UnlockGroupForm::CalEmbed": typeof CalEmbedComponent
  }
}
